import { render, staticRenderFns } from "./setting_user.vue?vue&type=template&id=78bb9618&scoped=true&"
import script from "./setting_user.vue?vue&type=script&lang=js&"
export * from "./setting_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bb9618",
  null
  
)

export default component.exports